import { render, staticRenderFns } from "./starshop-update-transaction-type.vue?vue&type=template&id=0da94065&scoped=true"
import script from "./starshop-update-transaction-type.vue?vue&type=script&lang=js"
export * from "./starshop-update-transaction-type.vue?vue&type=script&lang=js"
import style0 from "./starshop-update-transaction-type.vue?vue&type=style&index=0&id=0da94065&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da94065",
  null
  
)

export default component.exports